import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import '../Pages/Newhomepage.css'
import Logo from '../Images/PayneftLogo.png'
import { Link, useLocation } from "react-router-dom";

const Newnavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const location = useLocation();
  const pathname = location.pathname;


  return (
    <div className=" navmain_container sticky top-0 z-50">
      <div className="nav_items container ">
        {/* Burger Icon for Mobile */}
        <div className="burger_icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} size="lg" color="#E85D8A" />
        </div>

        {/* Logo */}
        <div className="logo_container">
          <a href="/">
            {/* <img src={Logo} alt="PayNeft Logo" /> */}
            <img src={Logo} alt="PayNeft" style={{height: "36px", width: "auto", objectFit: "contain"}} />
          </a>

          <div className="nav_list_items">
      <ul className="flex gap-6">
        <li >
          <a
            href="/"
            className={pathname === '/' ? '!text-[#E85D8A]' : 'text-white'}
          >
            Home
          </a>
        </li>
        <li>
          <a
            href="/features"
            className={pathname === '/features' ? '!text-[#E85D8A]' : 'text-white'}
          >
            Features
          </a>
        </li>
        <li>
          <a
            href="/pricing"
            className={pathname === '/pricing' ? '!text-[#E85D8A]' : 'text-white'}
          >
            Pricing
          </a>
        </li>
        <li>
          <a
            href="/aboutus"
            className={pathname === '/aboutus' ? '!text-[#E85D8A]' : 'text-white'}
          >
            About Us
          </a>
        </li>
        <li>
          <a
            href="/contactus"
            className={pathname === '/contactus' ? '!text-[#E85D8A]' : 'text-white'}
          >
            Contact Us
          </a>
        </li>
      </ul>
    </div>

        </div>

        {/* Navigation Items */}


        {/* Login Button */}



        <div className="Login_btn">
          <a
            href="https://business.payneft.in/payneft/pay/register"
            target="_blank"
            rel="noopener noreferrer"
          >
            Register
          </a>
        </div>
      </div>

      {/* Mobile Side Menu */}
      <div className={`mobile_menu ${isMenuOpen ? "open" : ""}`}>
        <div className="close_btn" onClick={toggleMenu}>
          {/* <FontAwesomeIcon icon={faTimes} size="lg"  /> */}
          <FontAwesomeIcon icon={faTimes} size="lg" style={{ color: 'white' }} />

        </div>
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/">Features</a>
          </li>
          <li>
            <a href="/pricing">Pricing</a>
          </li>
          <li>
            <a href="/aboutus">About Us</a>
          </li>
          <li>
            <a href="/Contactus">Contact Us</a>
          </li>
          <li><a href="https://business.payneft.in/payneft/pay/register" target="_blank" rel="noopener noreferrer">Register</a></li>

        </ul>
      </div>
    </div>
  );
};

export default Newnavbar;
